import * as React from "react";
import { App } from "./app"

interface LoadBarGWVm {
    app: App, // A reference back to the TreeView for validations etc.
    allCath:boolean
}

// ExtTabGW is a toggle button that either shows or hides the extended info window below a selected item
export class LoadBarGW extends React.Component<LoadBarGWVm, {percentage: number}> {
    constructor(props: LoadBarGWVm) {
        super(props)
    }

    state = {
        percentage: 0.0
    }
    
    // Renders the ext. info toggle button
    render() {
        if (this.props.allCath == true) {
            // Displaying a loadbar for all cathegories
            this.props.app.GetCore().InitLoadBarHandle(this)

            if (this.props.app.GetCore().GetInitStage() < 2) {
                // This render takes place at the very beginning before groups are prepared and starting to fill with data, so not much needs to show
                return <div style={{position:"relative", left:"5px", top:"4px"}}>Innhenter data...</div>
            }

            var gruppe = this.props.app.GetCore().GetDataLoadGroup()
            var percentage = this.props.app.GetLoadPercentage()

            var result = <div style={{ width: "100%" }}>
                <div style={{ width: "100%", height: "20px", backgroundColor: "#EEEEEE", position: "relative", top: "8px" }}>
                </div>
                <div style={{ height: "20px", width: this.GetLoadWidth(), backgroundColor: "#C0F0C0", position: "relative", top: "-12px" }}>
                </div>
                <div style={{ position: "relative", top: "-31px", left: "6px" }}>
                    {"Forbereder søk: " + this.props.app.GetLoadPercentage().toString()}
                </div>
            </div>

            return result
        }
        else {
            // Displaying a loadbar for the last selected nobb group
            this.props.app.GetCore().InitLoadBarHandle(this)
            var gruppe = this.props.app.GetCore().GetDataLoadGroup()
            const barwidthStr = "100%"

            var result = <div></div>

            if (this.props.app.GetLoadPercentage() != "none") {
                result = <div style={{ width: "100%" }}>
                    <div style={{ width: "100%", height: "20px", backgroundColor: "#EEEEEE", position: "relative", top: "8px" }}>
                    </div>
                    <div style={{ height: "20px", width: this.GetLoadWidth(), backgroundColor: "#C0F0C0", position: "relative", top: "-12px" }}>
                    </div>
                    <div style={{ position: "relative", left: "6px", top: "-31px" }}>
                        {"Forbereder søk: " + this.props.app.GetLoadPercentage().toString()}
                    </div>
                </div>
            }
            else {
                result = <div>
                    <div style={{ position: "relative", left: "6px", top: "-31px" }}>
                        {"(Gruppe finnes ikke i prisbok)"}
                    </div>
                </div>
            }

            return result
        }
    }
    
    // Returns a string that tells how many pixels broad should the loaded side of the loading percentage bar be.
    GetLoadWidth() {
        var pixels = (this.props.app.GetCore().GetLoadPercentage() * 100).toString()
        var result = ""
        for (var i = 0; i < pixels.length; i++) {
            if (pixels.charAt(i) == '.') {
                break
            }
            else {
                result += pixels.charAt(i)
            }
        }

        return result + "%"
    }
}



// WEBPACK FOOTER //
// ./client/view/LoadBarGW.tsx